import { FC } from 'react';
import type { NavItem } from '../../types';
import NavItemContent from './NavItemContent';

interface NavItemLinkProps {
  item: NavItem;
  isExpanded: boolean;
}

const NavItemLink: FC<NavItemLinkProps> = ({ item, isExpanded }) => {
  return (
    <a
      href={item.href}
      rel='noreferrer'
      className='w-full h-full'
      aria-current={item.isActive ? 'page' : undefined}
      aria-label={
        item.isExternalLink ? `${item.label}` : item.ariaLabel || item.label
      }
    >
      <NavItemContent item={item} hideIcon={!isExpanded} />
    </a>
  );
};

export default NavItemLink;
